import { render, staticRenderFns } from "./addReserveServiceList.vue?vue&type=template&id=08bd132d&scoped=true"
import script from "./addReserveServiceList.vue?vue&type=script&lang=js"
export * from "./addReserveServiceList.vue?vue&type=script&lang=js"
import style0 from "./addReserveServiceList.vue?vue&type=style&index=0&id=08bd132d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bd132d",
  null
  
)

export default component.exports